import defaultState from '../default';

const light = (params) => defaultState.light(params);

export default light;
